import { FC, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from '~/utils/helpers';
import './style.scss';

const DashboardSkeletons: FC = (): ReactElement => {
  return (
    <div className="d-flex flex-row gap-20 dashboard-skeleton">
      {emptyArray(4).map((_, index) => (
        <Skeleton key={index} height={292} style={{ borderRadius: 20 }} />
      ))}
    </div>
  );
};

export default DashboardSkeletons;
